export const importObjectTypeList = [
  { label: "CASE_DOC_SIGN", value: "CaseDocsign" },
  { label: "JOB_TITLE", value: "JobTitle" },
  { label: "USER_PROFILE", value: "UserProfile" },
  { label: "BUSINESS_UNIT", value: "BusinessUnit" },
  { label: "USER", value: "UserForm" },
  { label: "UPLOAD_DOCUMENT_INVALID", value: "InvalidProcessDetail" },
  { label: "DOCUMENT_STATISTIC_NEARLY_EXPIRED", value: "DocsignNearlyExpired" },
  { label: "DOCUMENT_STATISTIC_BY_CASE", value: "DocsignByCaseManagement" },
];

export const importRecordStatus = [
  { key: "O", badgeColor: "success" },
  { key: "C", badgeColor: "danger" },
];

export const importAuthStatus = [
  { key: "M", badgeColor: "primary" },
  { key: "P", badgeColor: "warning" },
  { key: "A", badgeColor: "success" },
  { key: "R", badgeColor: "danger" },
];

export const getInitImportParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
  };
};
